import React, { useState } from "react";
import { jsPDF } from "jspdf";
import "./RateManagement.css";

const RateManagement = () => {
  // View State
  const [activeView, setActiveView] = useState("rate"); // "rate" or "readyreckoner"

  // Rate Management State
  const [area, setArea] = useState("");
  const [isSeparateRate, setIsSeparateRate] = useState("");
  const [landRate, setLandRate] = useState("");
  const [residentialRate, setResidentialRate] = useState("");
  const [commercialRate, setCommercialRate] = useState("");
  const [industrialRate, setIndustrialRate] = useState("");
  const [searchArea, setSearchArea] = useState("");
  const [rates, setRates] = useState([]);

  // ReadyReckoner State
  const [hasSeparateRate, setHasSeparateRate] = useState("आहे");
  const [areaName, setAreaName] = useState("");
  const [rrLandRate, setRRLandRate] = useState("");
  const [rrResidentialRate, setRRResidentialRate] = useState(0);
  const [rrCommercialRate, setRRCommercialRate] = useState(0);
  const [rrIndustrialRate, setRRIndustrialRate] = useState(0);
  const [readyReckonerList, setReadyReckonerList] = useState([]);

  // Rate Management Functions
  const addRate = () => {
    if (!area || !isSeparateRate) {
      alert("सर्व आवश्यक माहिती भरा");
      return;
    }
    setRates([
      ...rates,
      {
        id: Date.now(),
        area,
        isSeparateRate,
        landRate: landRate || 0,
        residentialRate: residentialRate || 0,
        commercialRate: commercialRate || 0,
        industrialRate: industrialRate || 0,
      },
    ]);
    resetForm();
    setActiveView("readyreckoner");
  };

  const resetForm = () => {
    setArea("");
    setIsSeparateRate("");
    setLandRate("");
    setResidentialRate("");
    setCommercialRate("");
    setIndustrialRate("");
  };

  const deleteRate = (id) => {
    setRates(rates.filter((r) => r.id !== id));
  };

  const filteredRates = rates.filter((r) =>
    r.area.toLowerCase().includes(searchArea.toLowerCase())
  );

  // ReadyReckoner Functions
  const handleSaveReadyReckoner = () => {
    if (!areaName.trim()) {
      alert("कृपया विभाग / उपविभाग / गाव नाव भरा");
      return;
    }

    const newRecord = {
      id: Date.now(),
      hasSeparateRate,
      areaName,
      landRate: rrLandRate || 0,
      residentialRate: rrResidentialRate || 0,
      commercialRate: rrCommercialRate || 0,
      industrialRate: rrIndustrialRate || 0,
    };

    setReadyReckonerList([...readyReckonerList, newRecord]);
    resetReadyReckonerForm();
  };

  const resetReadyReckonerForm = () => {
    setHasSeparateRate("आहे");
    setAreaName("");
    setRRLandRate("");
    setRRResidentialRate(0);
    setRRCommercialRate(0);
    setRRIndustrialRate(0);
  };

  const handleBackToRate = () => {
    setActiveView("rate");
  };

  const generatePDF = async (type = "rate") => {
    try {
      const pdf = new jsPDF("p", "mm", "a4");
      const pageWidth = pdf.internal.pageSize.getWidth();
      
      pdf.setFillColor(79, 131, 163);
      pdf.rect(0, 0, pageWidth, 15, "F");
      pdf.setTextColor(255, 255, 255);
      pdf.setFontSize(16);
      
      let tableData = [];
      let header = [];
      let fileName = "";
      
      if (type === "rate") {
        pdf.text("दरांची माहिती", pageWidth / 2, 10, { align: "center" });
        header = ["अ.क्र.", "क्षेत्र", "स्वतंत्र दर", "जमिन दर", "आवास दर", "व्यावसायिक दर", "औद्योगिक दर"];
        tableData = rates.map((item, index) => [
          index + 1,
          item.area,
          item.isSeparateRate,
          item.landRate,
          item.residentialRate,
          item.commercialRate,
          item.industrialRate
        ]);
        fileName = "दर-यादी.pdf";
      } else {
        pdf.text("रेडीरेकनर दरांची माहिती", pageWidth / 2, 10, { align: "center" });
        header = ["अ.क्र.", "क्षेत्र नाव", "स्वतंत्र दर", "जमिन दर", "आवास दर", "व्यावसायिक दर", "औद्योगिक दर"];
        tableData = readyReckonerList.map((item, index) => [
          index + 1,
          item.areaName,
          item.hasSeparateRate,
          item.landRate,
          item.residentialRate,
          item.commercialRate,
          item.industrialRate
        ]);
        fileName = "रेडीरेकनर-दर-यादी.pdf";
      }
      
      pdf.setTextColor(0, 0, 0);
      pdf.setFontSize(10);
      pdf.text(`तारीख: ${new Date().toLocaleDateString("en-GB")}`, 15, 25);
      
      pdf.autoTable({
        head: [header],
        body: tableData,
        startY: 32,
        theme: "grid",
        headStyles: {
          fillColor: [241, 244, 255],
          textColor: [44, 62, 80],
          fontStyle: "bold",
          fontSize: 10
        },
        bodyStyles: {
          textColor: [73, 80, 87],
          fontSize: 9
        },
        alternateRowStyles: {
          fillColor: [248, 249, 250]
        }
      });
      
      const pageCount = pdf.internal.pages.length - 1;
      for (let i = 1; i <= pageCount; i++) {
        pdf.setPage(i);
        pdf.setFontSize(9);
        pdf.setTextColor(128, 128, 128);
        pdf.text(`पृष्ठ ${i} / ${pageCount}`, pageWidth / 2, pdf.internal.pageSize.getHeight() - 10, { align: "center" });
      }
      
      pdf.save(fileName);
    } catch (error) {
      alert("PDF तयार करताना त्रुटी: " + error.message);
    }
  };

  const deleteReadyReckoner = (id) => {
    setReadyReckonerList(readyReckonerList.filter((r) => r.id !== id));
  };

  return (
    <div>
      {activeView === "rate" ? (
        <>
          {/* Rate Management Form */}
          <div className="card-box">
            <div className="title">दरांची माहिती</div>

        {/* Add Form */}
        <div className="row mb-3">
          <div className="col-md-3">
            <label className="form-label fw-semibold">विभाग / उपविभाग / गाव</label>
            <select
              className="form-control"
              value={area}
              onChange={(e) => setArea(e.target.value)}
            >
              <option value="">निवडा</option>
              <option value="SANGLI">SANGLI</option>
              <option value="PUNE">PUNE</option>
            </select>
          </div>

          <div className="col-md-3">
            <label className="form-label fw-semibold">स्वतंत्र दर आहेत का</label>
            <select
              className="form-control"
              value={isSeparateRate}
              onChange={(e) => setIsSeparateRate(e.target.value)}
            >
              <option value="">निवडा</option>
              <option value="आहेत">आहेत</option>
              <option value="नाही">नाही</option>
            </select>
          </div>

          <div className="col-md-2">
            <label className="form-label fw-semibold">जमीन दर / चौ.मी</label>
            <input
              type="number"
              className="form-control"
              value={landRate}
              onChange={(e) => setLandRate(e.target.value)}
              placeholder="0"
            />
          </div>

          <div className="col-md-2">
            <label className="form-label fw-semibold">निवासी</label>
            <input
              type="number"
              className="form-control"
              value={residentialRate}
              onChange={(e) => setResidentialRate(e.target.value)}
              placeholder="0"
            />
          </div>

          <div className="col-md-2">
            <label className="form-label fw-semibold">व्यापारी</label>
            <input
              type="number"
              className="form-control"
              value={commercialRate}
              onChange={(e) => setCommercialRate(e.target.value)}
              placeholder="0"
            />
          </div>

          <div className="col-md-2 mt-3">
            <label className="form-label fw-semibold">औद्योगिक</label>
            <input
              type="number"
              className="form-control"
              value={industrialRate}
              onChange={(e) => setIndustrialRate(e.target.value)}
              placeholder="0"
            />
          </div>

          <div className="col-md-2 mt-4">
            <button className="btn btn-primary w-100" onClick={addRate}>
              नोंदणी करा
            </button>
          </div>
        </div>

        {/* Search + Count */}
        <div className="row mb-3 align-items-end">
          <div className="col-md-4">
            <label className="form-label fw-semibold">शोधा</label>
            <input
              type="text"
              className="form-control"
              value={searchArea}
              onChange={(e) => setSearchArea(e.target.value)}
              placeholder="गाव / विभाग"
            />
          </div>

          <div className="col-md-3">
            <div className="count-box">
              एकूण दरे : <br />
              {filteredRates.length}
            </div>
          </div>
        </div>

        {/* Table */}
        <div className="table-header">
          <h3>दरांची माहिती यादी</h3>
          <div className="pdf-buttons">
            <button className="btn-pdf-all" onClick={() => generatePDF("rate")}>
              📄 सर्व PDF
            </button>
          </div>
        </div>
        <table className="table table-bordered">
          <thead>
            <tr>
              <th>अ.क्र.</th>
              <th>स्वतंत्र दर</th>
              <th>विभाग / गाव</th>
              <th>जमीन दर</th>
              <th>निवासी</th>
              <th>व्यापारी</th>
              <th>औद्योगिक</th>
              <th>क्रिया</th>
            </tr>
          </thead>
          <tbody>
            {filteredRates.length === 0 ? (
              <tr>
                <td colSpan="8" className="text-center text-muted p-3">
                  माहिती उपलब्ध नाही
                </td>
              </tr>
            ) : (
              filteredRates.map((r, index) => (
                <tr key={r.id}>
                  <td>{index + 1}</td>
                  <td>{r.isSeparateRate}</td>
                  <td>{r.area}</td>
                  <td>₹{r.landRate}</td>
                  <td>₹{r.residentialRate}</td>
                  <td>₹{r.commercialRate}</td>
                  <td>₹{r.industrialRate}</td>
                  <td>
                    <button
                      className="btn btn-sm btn-danger"
                      onClick={() => deleteRate(r.id)}
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>

        {/* Navigation to Ready Reckoner */}
        <div style={{ marginTop: "20px", textAlign: "center" }}>
          <button 
            className="btn-nav-reckoner" 
            onClick={() => setActiveView("readyreckoner")}
          >
            रेडीरेकन दरांची माहिती →
          </button>
        </div>
      </div>
        </>
      ) : (
        <>
          {/* Ready Reckoner Form */}
      <div className="card-box mt-4">
        <div className="rr-header">रेडीरेकन दरांची माहिती</div>

        <div className="rr-wrapper">
          {/* Navigation Button */}
          <div style={{ marginBottom: "20px" }}>
            <button className="btn-nav-rate" onClick={handleBackToRate}>
              ← दरांची माहिती
            </button>
          </div>

          {/* Radio */}
          <div className="rr-label">
            रेडीरेकनमध्ये नगरसेवांचे स्वतंत्र दर निश्चित केले आहेत का
          </div>
          <div style={{ marginTop: "6px" }}>
            <label className="rr-radio">
              <input
                type="radio"
                value="आहे"
                checked={hasSeparateRate === "आहे"}
                onChange={(e) => setHasSeparateRate(e.target.value)}
              />{" "}
              आहेत
            </label>

            <label className="rr-radio">
              <input
                type="radio"
                value="नाही"
                checked={hasSeparateRate === "नाही"}
                onChange={(e) => setHasSeparateRate(e.target.value)}
              />{" "}
              नाही
            </label>
          </div>

          {/* Area */}
          <div className="rr-label">
            विभाग / उपविभाग / गाव <span className="rr-required">*</span>
          </div>
          <input
            type="text"
            className="rr-input"
            value={areaName}
            onChange={(e) => setAreaName(e.target.value)}
            placeholder="उदा. संगली, पुणे"
          />

          {/* Land Rate */}
          <div className="rr-label">जमीन दर/चौ.मी</div>
          <input
            type="number"
            className="rr-input"
            value={rrLandRate}
            onChange={(e) => setRRLandRate(e.target.value)}
            placeholder="0"
          />

          {/* Residential */}
          <div className="rr-label">निवासी सदनिका</div>
          <input
            type="number"
            className="rr-input"
            value={rrResidentialRate}
            onChange={(e) => setRRResidentialRate(e.target.value)}
            placeholder="0"
          />

          {/* Commercial */}
          <div className="rr-label">व्यापारी/वाणिज्यक (ऑफिस/दुकाने)</div>
          <input
            type="number"
            className="rr-input"
            value={rrCommercialRate}
            onChange={(e) => setRRCommercialRate(e.target.value)}
            placeholder="0"
          />

          {/* Industrial */}
          <div className="rr-label">औद्योगिक</div>
          <input
            type="number"
            className="rr-input"
            value={rrIndustrialRate}
            onChange={(e) => setRRIndustrialRate(e.target.value)}
            placeholder="0"
          />

          {/* Buttons */}
          <div className="rr-buttons">
            <button className="btn-save" onClick={handleSaveReadyReckoner}>
              जतन करा
            </button>
            <button className="btn-reset" onClick={resetReadyReckonerForm}>
              रीसेट करा
            </button>
            <button className="btn-back" onClick={handleBackToRate}>
              परत दरांची माहितीकडे
            </button>
          </div>
        </div>
      </div>

      {/* Ready Reckoner List */}
      {readyReckonerList.length > 0 && (
        <div className="card-box mt-4">
          <div className="table-header">
            <h3>रेडीरेकन दरांची यादी</h3>
            <div className="pdf-buttons">
              <button className="btn-pdf-all" onClick={() => generatePDF("readyreckoner")}>
                📄 सर्व PDF
              </button>
            </div>
          </div>
          <table className="table table-bordered">
            <thead>
              <tr>
                <th>अ.क्र.</th>
                <th>विभाग / गाव</th>
                <th>स्वतंत्र दर</th>
                <th>जमीन दर</th>
                <th>निवासी</th>
                <th>व्यापारी</th>
                <th>औद्योगिक</th>
                <th>क्रिया</th>
              </tr>
            </thead>
            <tbody>
              {readyReckonerList.map((record, index) => (
                <tr key={record.id}>
                  <td>{index + 1}</td>
                  <td>{record.areaName}</td>
                  <td>{record.hasSeparateRate}</td>
                  <td>₹{record.landRate}</td>
                  <td>₹{record.residentialRate}</td>
                  <td>₹{record.commercialRate}</td>
                  <td>₹{record.industrialRate}</td>
                  <td>
                    <button
                      className="btn btn-sm btn-danger"
                      onClick={() => deleteReadyReckoner(record.id)}
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
        </>
      )}
    </div>
  );
};

export default RateManagement;
